import { useQuery } from 'hooks/useCustomQuery';
import { useSelector, useDispatch } from 'react-redux';
import getTriggers from '@/API/Triggers/getTriggers';
import { addSpacing } from '@/utils/utils';
import { toast } from 'react-toastify';

const useGetTriggers = (setTableData) => {
    const { currentScope } = useSelector((state) => state.login);
    const { currentCompany, currentPartner, currentWholesaler } = useSelector(
        (state) => state.navigationLists,
    );
    const { loading: tableLoading } = useSelector((state) => state.table);
    const dispatch = useDispatch();

    return useQuery({
        queryKey: ['triggers', currentScope],
        queryFn: async () => {
            try {
                const res = await getTriggers(
                    currentScope,
                    currentCompany,
                    currentPartner,
                    currentWholesaler,
                );

                const processedData = res.map(({ eventName, ...rest }) => ({
                    ...rest,
                    eventName: addSpacing(eventName),
                }));

                setTableData((prev) => ({
                    ...prev,
                    data: processedData,
                }));
                // CHANGE_TABLE_LOADING toggles rather than sets loading, so only
                // dispatch while it's still true (initial load) — otherwise a
                // refetch (e.g. after save/cancel) flips it back to true and
                // Navbar's scope selector stays disabled until the page remounts.
                if (tableLoading) {
                    dispatch({
                        type: 'CHANGE_TABLE_LOADING',
                    });
                }

                return res;
            } catch (error) {
                const errorMessage = `Failed to get triggers: ${error}`;
                toast.error(errorMessage);
                throw new Error(errorMessage);
            }
        },
        refetchOnWindowFocus: false,
        staleTime: 0,
        enabled:
            Boolean(currentWholesaler) &&
            Boolean(currentPartner) &&
            Boolean(currentCompany),
    });
};

export default useGetTriggers;
